import request from "@/utils/request";

//改配历史查询
export function queryMfOrderByTransferStatus(param) {
  return request({
    url: '/web/queryMainSystem/queryMfOrderByTransferStatus',
    method: 'post',
    data: param
  })
}

export function queryMdAccessories(planId) {
  return request({
    url: '/web/queryMainSystem/queryMdAccessoriesById',
    method: 'post',
    data: planId
  })
}

// 发票下载
export function downloadInvoice(invoiceUrl) {
    return request({
        url: '/cts-file-service/cloud/filesystem/downloadFile/' + invoiceUrl,
        method: 'get',
        data: invoiceUrl
    })
}

// 发票查询
export function queryInvoice(searchData) {
    return request({
        url: '/web/queryMainSystem/queryInvoice',
        method: 'post',
        data: searchData
    })
}

export function queryWebInvoice(searchData) {
    return request({
        url: '/web/queryMainSystem/queryInvoiceFreight',
        method: 'post',
        data: searchData
    })
}

// 船期查询
export function queryShippingDate(searchData) {
    return request({
        url: '/web/queryMainSystem/queryShippingDate',
        method: 'post',
        data: searchData
    })
}

// 船公司拓展信息查询
export function queryMdCarrierInfo(searchData) {
    return request({
        url: '/web/queryMainSystem/queryMdCarrierInfo',
        method: 'post',
        data: searchData
    })
}

// 账单查询(isDetail(必填,"Y":账单明细 "N":账单查询,使用此字段区分查询和明细))
export function queryBill(searchData) {
    return request({
        url: '/web/queryMainSystem/queryBill',
        method: 'post',
        data: searchData
    })
}

// 华贸公共消息查询(infoType:NS-船公司 NT-华贸)
export function queryMdInfo(searchData) {
    return request({
        url: '/web/queryMainSystem/queryMdInfo',
        method: 'post',
        data: searchData
    })
}

//消息订阅查询
export function querySubscription(searchData) {
    return request({
        //url: '/ctsweb/message/getSubscription',
        url: '/web/queryMainSystem/querySubscription',
        method: 'post',
        data: searchData
    })
}

//提单超链接
export function queryBillLading(searchData) {
    return request({
        url: '/web/queryMainSystem/queryBillLading',
        method: 'post',
        data: searchData
    })
}

//舱单超链接
export function queryManifestHyperlinks(searchData) {
    return request({
        url: '/web/queryMainSystem/queryManifestHyperlinks',
        method: 'post',
        data: searchData
    })
}